import Modal from "./Modal";
import React, { useEffect, useRef } from "react";
import { ModalSize } from "../enums/ModalSize";
import CenteredFullWidthDiv from "./CenteredFullWidthDiv";
import { useFormikContext } from "formik";
import { FormValues } from "../common/FormValues";
import Checkbox from "../input/Checkbox";
import Button from "../button/Button";
import { PdsModal } from "@principal/design-system-react";

export type EftModalProps = {
    onClose?: (e: Event) => void,
    inModal?: boolean
}

const EftModal = (props: EftModalProps) => {
    const { values } = useFormikContext<FormValues>();
    const consent = (values as any).eftConsent;
    const modalRef = useRef<typeof PdsModal & { openModal: Function, closeModal: Function }>(null);

    useEffect(() => {
        if(props.inModal && modalRef.current) {
            modalRef.current.openModal();
        }
    }, [props.inModal])

    const handleContinue = () => {
        modalRef.current?.closeModal(new CustomEvent('close'));
    }

    return <Modal id="eft-consent-validation"
                  headerText="Authorization agreement for electronic funds transfer"
                  ref={modalRef}
                  modalContent={
                      <div>
                          <div>I Hereby Authorize:</div>
                          <ul>
                              <li>
                                  The Company to initiate credit entries to my account, at the financial institution named above (herein called Bank).
                              </li>
                              <li>
                                  The Company, if necessary, to initiate debit entries and adjustments to correct any credit entries made in error.
                              </li>
                              <li>
                                  The Bank to credit and/or debit entries to my account.
                              </li>
                          </ul>
                          <div>This Authorization:</div>
                          <ul>
                              <li>
                                  Applies to any payments that hereafter become due and payable to me under the provisions of the contract(s) identified by the above Account Number.
                              </li>
                              <li>
                                  This authorization is to remain in full force and effect until Principal Life Insurance Company has written notice from me of its termination.
                              </li>
                              <li>
                                  I understand and agree that any payment(s) made into an incorrect bank account pursuant to the information reported on this form, will be forfeited by me and that Principal Life Insurance has no obligation to retrieve those funds or make replacement payment(s) to me.
                              </li>
                          </ul>
                          <CenteredFullWidthDiv divContent={<p>
                              Note: If you wish to change your payment preference, please close this dialog box, and go back to the payments page.
                          </p>}/>
                          <CenteredFullWidthDiv divContent={
                              <Checkbox id="eft-consent" label="I agree"/>
                          }/>
                      </div>}
                  modalFooter={<>
                      {consent && <Button buttonContent="Continue" onClick={handleContinue}/>}
                  </>}
                  onClose={props.onClose}
                  modalSize={ModalSize.LARGE}
                  openOnLoad={false}
                  closeable={true}/>;
}

export default EftModal;
